import { useSelector } from "react-redux";
import { groupsHavePermission } from "./permissions";

// True when the current user holds at least one of the given permission(s)
// (any-of), resolved from their Cognito groups plus the implicit authenticated role.
// UI gating only, not security: long term the API enforces permissions and supplies
// the user's effective ones, and this hook reads those instead of resolving locally
// (see auth/permissions.js).
//
// @param {string | string[]} permissionOrPermissions
export const useHasPermission = (permissionOrPermissions) => {
  const groups = useSelector((state) => state.loginReducer?.groups);
  return groupsHavePermission(groups, permissionOrPermissions);
};
